import { ArrowDownSmall as ArrowDownSmall_kojaro } from './ArrowDownSmall.kojaro';
import { ArrowDownSmall as ArrowDownSmall_phosphor } from './ArrowDownSmall.phosphor';
import { ArrowDownSmall as ArrowDownSmall_zoomg } from './ArrowDownSmall.zoomg';
import { ArrowDownSmall as ArrowDownSmall_zoomit } from './ArrowDownSmall.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return ArrowDownSmall_kojaro;

    case 'zoomg':
      return ArrowDownSmall_zoomg;

    case 'phosphor':
      return ArrowDownSmall_phosphor;

    default:
      return ArrowDownSmall_zoomit;
  }
};

export const ArrowDownSmall = IconRenderer();
